import type { Channel, ChannelType, ChannelStatus } from '@conversia/shared-types';
import { api } from './client';

/** Endpoints de canales. Prefijo: /api/channels */

export interface CreateChannelInput {
  type: ChannelType;
  name: string;
  config?: Record<string, unknown>;
}

export interface ConnectResult {
  status: ChannelStatus;
  qr?: string;
}

export const listChannels = () => api.get<Channel[]>('/api/channels');

export const getChannel = (id: string) => api.get<Channel>(`/api/channels/${id}`);

export const getChannelStatus = (id: string) =>
  api.get<{ status: ChannelStatus }>(`/api/channels/${id}/status`);

export const createChannel = (input: CreateChannelInput) =>
  api.post<Channel>('/api/channels', input);

export const updateChannel = (
  id: string,
  input: { name?: string; config?: Record<string, unknown>; defaultAgentId?: string | null },
) => api.patch<Channel>(`/api/channels/${id}`, input);

export const connectChannel = (id: string) =>
  api.post<ConnectResult>(`/api/channels/${id}/connect`);

export const disconnectChannel = (id: string) =>
  api.post<{ success: boolean }>(`/api/channels/${id}/disconnect`);

export const deleteChannel = (id: string) =>
  api.del<{ success: boolean }>(`/api/channels/${id}`);

/** Saca el canal del simulacro: desde ahí manda de verdad. El servidor exige el nombre exacto del canal. */
export const quitarSimulacro = (id: string, confirmacion: string) =>
  api.post<{ canal: Channel }>(`/api/channels/${id}/simulacro/quitar`, { confirmacion });

/** Vuelve a poner el candado (el freno): el canal deja de mandar. No pide confirmación. */
export const ponerSimulacro = (id: string) =>
  api.post<{ canal: Channel }>(`/api/channels/${id}/simulacro/poner`);
